import generateUtilityClass from "../../utils/generateUtilityClass/generateUtilityClass.es.js";
import generateUtilityClasses from "../../utils/generateUtilityClasses/generateUtilityClasses.es.js";
const getDayCalendarUtilityClass = (slot) => generateUtilityClass("MuiDayCalendar", slot);
generateUtilityClasses("MuiDayCalendar", ["root", "header", "weekDayLabel", "loadingContainer", "slideTransition", "monthContainer", "weekContainer", "weekNumberLabel", "weekNumber"]);
export {
  getDayCalendarUtilityClass
};
//# sourceMappingURL=dayCalendarClasses.es.js.map
